import axios from "axios";
const SP_HOST = process.env.VUE_APP_SP_HOST;

export default () => {
  return axios({
    method: "GET",
    url:
      "https://" +
      SP_HOST +
      "/sites/portal-new/_api/Web/CurrentUser?$select=email",
    headers: {
      Accept: "application/json;odata=verbose;",
      "Content-Type": "application/json;odata=verbose;",
    },
  });
};
